'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearProps = exports.trackingEvent = exports.isRegistrationClickedAction = exports.accountRecoveryClicked = exports.isAccountRecoveryClickedAction = exports.registrationClicked = exports.isLoginFormInitialiationFailedAction = exports.loginFormInitialiationFailed = exports.isLoginFormInitializedAction = exports.loginFormInitialized = exports.initForm = exports.isFetchFinishedAction = exports.fetchFinished = exports.isFetchStartedAction = exports.fetchStarted = undefined;

var _authClientComponent = require('@wh/auth-client-component');

var _authClientComponent2 = _interopRequireDefault(_authClientComponent);

var _utils = require('./../utils/utils');

var _utils2 = _interopRequireDefault(_utils);

var _constants = require('./../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Fetch request was started
 * @returns {Object} The action to be dispatched
 */
var fetchStarted = exports.fetchStarted = function fetchStarted() {
  return {
    type: _constants.FETCH_STARTED
  };
};

/**
 * Checks if the passed action is of type FETCH_STARTED
 * @param {Object} action The action to be checked
 * @returns {Boolean} True if type is equal to FETCH_STARTED. False otherwise.
 */

var isFetchStartedAction = exports.isFetchStartedAction = (0, _utils2.default)(_constants.FETCH_STARTED);

/**
 * Fetch was finished
 * @returns {Object} The action to be dispatched
 */
var fetchFinished = exports.fetchFinished = function fetchFinished() {
  return {
    type: _constants.FETCH_FINISHED
  };
};

/**
 * Checks if the passed action is of type FETCH_FINISHED
 * @param {Object} action The action to be checked
 * @returns {Boolean} True if type is equal to FETCH_FINISHED. False otherwise.
 */
var isFetchFinishedAction = exports.isFetchFinishedAction = (0, _utils2.default)(_constants.FETCH_FINISHED);

/**
 * Init form - fetch form defaults from CAS url
 * @param {CasClient} casClient CAS client library
 * @returns {Object} The action to be dispatched
 */
var initForm = exports.initForm = function initForm(casClient) {
  return {
    type: _constants.INIT_FORM,
    casClient: casClient
  };
};

/**
 * Form defaults were fetched
 * @param {Object} dataFromCas Data from CAS: form_defaults and recoverLoginUrl
 * @returns {Object} The action to be dispatched
 */
var loginFormInitialized = exports.loginFormInitialized = function loginFormInitialized(dataFromCas) {
  return {
    type: _constants.FORM_INITIALIZED,
    dataFromCas: dataFromCas
  };
};

/**
 * Checks if the passed action is of type FORM_INITIALIZED
 * @param {Object} action The action to be checked
 * @returns {Boolean} True if type is equal to FORM_INITIALIZED. False otherwise.
 */
var isLoginFormInitializedAction = exports.isLoginFormInitializedAction = (0, _utils2.default)(_constants.FORM_INITIALIZED);

/**
 * Error when fetching form defaults
 * @returns {Object} The action to be dispatched
 */
var loginFormInitialiationFailed = exports.loginFormInitialiationFailed = function loginFormInitialiationFailed() {
  return {
    type: _constants.FORM_INITIALIZATION_FAILED
  };
};

/**
 * Checks if the passed action is of type FORM_INITIALIZATION_FAILED
 * @param {Object} action The action to be checked
 * @returns {Boolean} True if type is equal to FORM_INITIALIZATION_FAILED. False otherwise.
 */
var isLoginFormInitialiationFailedAction = exports.isLoginFormInitialiationFailedAction = (0, _utils2.default)(_constants.FORM_INITIALIZATION_FAILED);

/**
 * Registration button was clicked
 * @returns {Object} The action to be dispatched
 */
var registrationClicked = exports.registrationClicked = function registrationClicked() {
  return {
    type: _constants.REGISTRATION_CLICKED
  };
};

/**
 * Checks if the passed action is of type ACCOUNT_RECOVERY_CLICKED
 * @param {Object} action The action to be checked
 * @returns {Boolean} True if type is equal to ACCOUNT_RECOVERY_CLICKED. False otherwise.
 */
var isAccountRecoveryClickedAction = exports.isAccountRecoveryClickedAction = (0, _utils2.default)(_constants.ACCOUNT_RECOVERY_CLICKED);

/**
 * Account recovery button was clicked
 * @returns {Object} The action to be dispatched
 */
var accountRecoveryClicked = exports.accountRecoveryClicked = function accountRecoveryClicked() {
  return {
    type: _constants.ACCOUNT_RECOVERY_CLICKED
  };
};

/**
 * Checks if the passed action is of type REGISTRATION_CLICKED
 * @param {Object} action The action to be checked
 * @returns {Boolean} True if type is equal to REGISTRATION_CLICKED. False otherwise.
 */
var isRegistrationClickedAction = exports.isRegistrationClickedAction = (0, _utils2.default)(_constants.REGISTRATION_CLICKED);

/**
 * General tracking event
 * @param {string} eventName Event name
 * @param {Object} trackingData Data sent to the tracking system
 * @returns {Object} The action to be dispatched
 */
var trackingEvent = exports.trackingEvent = function trackingEvent(eventName, trackingData) {
  return {
    type: _constants.EVENT_TO_TRACK_CUSTOM,
    eventName: eventName,
    trackingData: trackingData || {}
  };
};

/**
 * Clear temporary props after using them
 * @returns {Object} The action to be dispatched
 */
var clearProps = exports.clearProps = function clearProps() {
  return {
    type: _constants.CLEAR_PROPS
  };
};
//# sourceMappingURL=actions.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/login-component/actions.js
// module id = 50
// module chunks = 0